import React from 'react'
import { useTheme } from 'styled-components'
import { rem } from 'polished'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import LeBusinessTravellerLogo from 'components/App/Header/Logo/logos/LeBusinessTravellerLogo'
import zIndex from 'styles/tools/z-index'

// Covers the page while an expired session is silently restored, so the
// momentary anonymous render is never shown.
function OidcSessionRestoreOverlay() {
  const theme = useTheme()

  return (
    <Group
      direction="vertical"
      gap={16}
      horizontalAlign="center"
      verticalAlign="center"
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: zIndex.modal,
        padding: rem(24),
        backgroundColor: theme.palette.neutral.surface.normalBackground,
      }}
    >
      <LeBusinessTravellerLogo height={30} />
      <LoadingIndicator inline />
      <BodyText variant="medium" align="center">Welcome back — signing you in again...</BodyText>
    </Group>
  )
}

export default OidcSessionRestoreOverlay
